import DaqastraHero from "../../assets/daqastra/summary/daqastra.png";
import PlumeTesting from "../../assets/daqastra/caseStudies/plume.gif";
import BoardSpec from "../../assets/daqastra/specs/boardSpec.JPG";

import React from "react";

export const daqastraData = {
  title: "DAQAstra",
  heroCards: [
    {
      title: "No-Code Data Acquisition",
      description: "Ridiculously easy configuration with plug-and-play simplicity. Control many peripherals with one board, infinitely customizable yet affordable and scalable",
    },
    {
      title: "Versatile Applications",
      description: "From lab experiments to the International Space Station, from rocket thruster testing to global telescope networks—proven in the most demanding environments",
    },
    {
      title: "Fast & Flexible",
      description: "Streamlines engineering workflows by unifying hardware and software in a fast, flexible system that adapts to complex applications whether in the lab or in space",
    },
  ],
  externalLink: "https://www.daqastra.com/",
  content: [
    {
      href: DaqastraHero,
    },
    {
      title: "Proven in Action",
      cards: [
        {
          title: "International Space Station",
          description: "Running critical experiments aboard the ISS, proving reliability in the harshest environment imaginable",
        },
        {
          title: "Rocket Engine Testing",
          description: "Powering rocket thruster plume testing for Purdue University with precise data acquisition and real-time control",
        },
        {
          title: "Sutter TKO Network",
          description: "Automating Sutter TKO telescope networks worldwide for advanced space domain awareness and asteroid detection",
        },
      ],
      href: PlumeTesting,
    },
    {
      title: "Built by Space Innovators",
      cards: [
        {
          description: "Created by TransAstra, the same engineers developing advanced telescope systems, satellite servicing, and asteroid mining technologies for sustainable space logistics",
        },
        {
          description: "Designed for NASA and Space Force missions, now available to streamline your engineering workflows",
        },
      ],
      href: BoardSpec,
    },
  ],
};

